import React, { useRef, useState, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { customWidgetEndpointLayers, customWidgetEndpoints } from '../../../config/widgetEndpoints';
import { customEnergySummaryChartFilterButtons } from '../../../config/chartFilterButtons';
import MachineLayoutComponent from '../../machinedetail/components/machinelayout.component';
import useHttpApiCall from '../../../services/useHttpApiCall';
import RefreshOnceTotalEnergyUse from '../../../common/chartautorefresh/refresh.once.total.enery.use';
import MainTotalEnergyUseContainer from '../../../common/layout/containers/main.total.energy.use.container';
import DateRangeSet from '../../../common/datetimepicker/daterangeset';

export default function waterflowTotalEnergyUseContainer(props) {
 //console.log("waterflowTotalEnergyUseContainer",props)
  const INITIALFILTER = '1day';
  const [initialFilter, setInitialFilter] = useState('1day');
  const charRef = useRef(undefined);
  const [chartApiData, setChartApiData] = useState([]);
  const [chartApiData2, setChartApiData2] = useState([]);
  const [payload, setPayload] = useState(undefined);
  const [selectEquipments, setSelectEquipments] = useState(null);
  const [graphFilter, setGraphFilter] = useState({
    filterMain: INITIALFILTER
  });
  const [filterByDateCheck, setFilterByDateCheck] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [apiDateRange, setApiDateRange] = useState([]);
  const comparisonFilter = useSelector((state) => state.comparisonFilter.set_comparison_filter);
  const set_equipment_filter = useSelector((state) => state.equipmentFilter.set_equipment_filter);
  const [apiParams, setApiParams] = useState(null);
  const [comparisonViewCheck, setComparisonViewCheck] = useState(false);
  const [config, setConfig] = useState({});
  const graphFilterObject = customEnergySummaryChartFilterButtons;
  const [data, loading, error] = useHttpApiCall(payload);
  const [togglePriceCheck, setTogglePriceCheck] = useState(false);
  const [daySummaryDrilldownDate, setDaySummaryDrilldownDate] = useState(null);
  const flexibleEquipmentEnabled=localStorage.getItem('flexible_equipment')=='true'?true:false

  const graphInfo = {
    isSummaryGraph: true
  }
  const graphApiCall = () => {
    if (
      (graphFilter.filterMain == '1week' || graphFilter.filterMain == '1month') &&
      daySummaryDrilldownDate
    ) {
      //console.log("debug1");
      setPayload({
        auth: true,
        url: flexibleEquipmentEnabled?customWidgetEndpointLayers.airflowEnergyUseSummary:customWidgetEndpoints.airflowEnergyUseSummary,
        params: {
          ...apiParams,
          duration: graphFilterObject[graphFilter.filterMain].drilldown,
          summary_date: daySummaryDrilldownDate
        }
      });
      charRef.current.chart.showLoading();
    } 
    else if (apiParams?.end_date_time && apiParams?.start_date_time && daySummaryDrilldownDate) {
      const filterDateRange = { start_date_time: apiDateRange[0], end_date_time: apiDateRange[1] }
      setPayload({
        auth: true,
        url: flexibleEquipmentEnabled ? customWidgetEndpointLayers.airflowEnergyUseSummary : customWidgetEndpoints.airflowEnergyUseSummary,
        params:  daySummaryDrilldownDate? {
          layer_type: props?.graphInfo?.layer_type,
          plant_code: props?.plant_code,
          sensor_type:props?.graphInfo?.sensor_type,
          duration: '1day',
          summary_date: daySummaryDrilldownDate
        }:{
          layer_type: props?.graphInfo?.layer_type,
          plant_code: props?.plant_code,
         sensor_type:props?.graphInfo?.sensor_type,
          ...filterDateRange
        } 
      });
    }
    else {
      console.log("debug2")
      //Main view
      setPayload({
        auth: true,
        url: flexibleEquipmentEnabled?customWidgetEndpointLayers.airflowEnergyUseSummary:customWidgetEndpoints.airflowEnergyUseSummary,
        params: apiParams
      });
    }
  };

  const unsetInnerDrilldown = () => {
    setDaySummaryDrilldownDate(null);
  };

  React.useEffect(() => {
    if (data && data.data) {
      let apiData = data.data;
      //console.log("apiData",apiData)
      
      if (flexibleEquipmentEnabled) {
       // console.log("props?.graphInfo?.sensor_type",props?.sensor_type)
        setSelectEquipments({
          equipment_length:apiData?.data?.equipments_count,
          is_equipment_filter_enabled: apiData?.data?.is_equipment_filter_enabled,
          equipmet_list_api_url: 'v1/layers/equipments/',
          equipmet_list_params: {
            get_equipment_preference: 1,
            process_id: apiData.process_id,
            plant_code: props?.plant_code,
            layer_type: props?.graphInfo?.layer_type ||props?.layer_type,
            sensor_type:props?.graphInfo?.sensor_type||props?.sensor_type
          },
          drilldown_level: 'custom',
          equipment_update_params: {
            process_id: apiData.process_id,
          }
        });
      } else {
        setSelectEquipments({
          equipment_length: apiData.equipments_count,
          is_equipment_filter_enabled: apiData.is_equipment_filter_enabled,
          equipmet_list_api_url: 'v0/equipments/',
          equipmet_list_params: {
            get_equipment_preference: 1,
            sub_division: props.sub_division,
            process_id: apiData.process_id
          },
          drilldown_level: 'custom',
          equipment_update_params: {
            sub_division: props.sub_division,
            process_id: apiData.process_id,
          }
        });
      }
    }
  }, [data]);

  React.useEffect(() => {
    if (
      set_equipment_filter.filter_update &&
      (flexibleEquipmentEnabled 
        ? set_equipment_filter.params.sensor_type == props?.graphInfo?.sensor_type
        : set_equipment_filter.params.sub_division == props.sub_division)
    ) {
      graphApiCall();
    }
  }, [set_equipment_filter.filter_update]);

  return (
    <div>
      <Suspense fallback={<span>Loading</span>}>
        <DateRangeSet
          graphFilter={graphFilter}
          setFilterByDateCheck={setFilterByDateCheck}
          filterByDateCheck={filterByDateCheck}
          dateRange={dateRange}
          setDateRange={setDateRange}
          setGraphFilter={setGraphFilter}
          INITIALFILTER={INITIALFILTER}
          setApiDateRange={setApiDateRange}
          graphInfo={graphInfo}

        />
        <RefreshOnceTotalEnergyUse
          graphApiCall={graphApiCall}
          data={data}
          loading={loading}
          error={error}
          comparisonViewCheck={comparisonViewCheck}
          comparisonFilter={comparisonFilter}
          graphFilter={graphFilter}
        />
        <MainTotalEnergyUseContainer
          initialFilter={initialFilter}
          setInitialFilter={setInitialFilter}
          togglePriceCheck={togglePriceCheck}
          setTogglePriceCheck={setTogglePriceCheck}
          comparisonViewCheck={comparisonViewCheck}
          data={data}
          charRef={charRef}
          setGraphFilter={setGraphFilter}
          setConfig={setConfig}
          chartApiData={chartApiData}
          chartApiData2={chartApiData2}
          config={config}
          setFilterByDateCheck={setFilterByDateCheck}
          apiDateRange={apiDateRange}
          apiParams={apiParams}
          setApiParams={setApiParams}
          props={props}
          graphFilter={graphFilter}
          graphApiCall={graphApiCall}
          INITIALFILTER={INITIALFILTER}
          filterByDateCheck={filterByDateCheck}
          setChartApiData={setChartApiData}
          setChartApiData2={setChartApiData2}
          setComparisonViewCheck={setComparisonViewCheck}
          comparisonFilter={comparisonFilter}
          setDaySummaryDrilldownDate={setDaySummaryDrilldownDate}
          daySummaryDrilldownDate={daySummaryDrilldownDate}
          daySummaryDrilldownEnabled={true}
        />
        <MachineLayoutComponent
          chartApiData={chartApiData}
          loading={loading}
          chartData={config}
          charRef={charRef}
          expandWindow={props.expandWindow}
          minimizeWindow={props.minimizeWindow}
          shouldExpand={props.shouldExpand}
          chartId={props.id}
          hasFilter={true}
          graphFilter={graphFilter}
          setGraphFilter={setGraphFilter}
          graphFilterObject={graphFilterObject}
          selectEquipments={selectEquipments}
          hasSettings={false}
          filterByDate={true}
          setFilterByDateCheck={setFilterByDateCheck}
          filterByDateCheck={filterByDateCheck}
          dateRange={dateRange}
          setDateRange={setDateRange}
          hasIncompletePeriodLegend={true}
          comparisonView={true}
          comparisonViewCheck={comparisonViewCheck}
          setComparisonViewCheck={setComparisonViewCheck}
          daySummaryDrilldownDate={daySummaryDrilldownDate}
          unsetInnerDrilldown={unsetInnerDrilldown}
          graphInfo={graphInfo}
        />
      </Suspense>
    </div>
  );
}
